// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__4-Zxb","file":"styles_file__1VtFZ"};